















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class List extends Vue {
  @Prop() private data: any;
  @Prop() private itemClick: any;
  @Prop() private selectedId: any;
  private memoizedBrokenPicturesMap: Set<string> = new Set();

  private imageCompareRegex: RegExp = /(cb=\d+)$/gi;

  private handleImageError(e: any) {
    if (e.target.src === '/img/default-device.png') {
      return;
    }

    this.memoizedBrokenPicturesMap.add(e.target.src.replace(this.imageCompareRegex, ''));
    e.target.src = '/img/default-device.png';
  }
}
